/**
 * GSAP Fade In Up Stagger Animation
 * 
 * HOW TO USE:
 * 1. Create a wrapper element with class "fade-in-up-stagger-wrapper"
 * 2. Add child elements with class "fade-in-up-stagger-item"
 * 3. Items will animate in sequence with a staggered delay
 * 
 * EXAMPLE:
 * <div class="fade-in-up-stagger-wrapper">
 *   <div class="fade-in-up-stagger-item">Item 1</div>
 *   <div class="fade-in-up-stagger-item">Item 2</div>
 *   <div class="fade-in-up-stagger-item">Item 3</div>
 * </div>
 * 
 * BONUS FEATURE:
 * If stagger items contain <a> links, they get hover scale effects automatically.
 * 
 * ANIMATION DETAILS:
 * - Each item starts: opacity 0, y: 20, scale: 0.8
 * - Duration: 0.5 seconds per item
 * - Stagger delay: 0.1 seconds between items
 * - Easing: back.out(1.7) (bouncy effect)
 * - Triggers when wrapper top reaches 95% of viewport height
 * - Plays once only
 * - Hover effect: links scale to 1.1 on mouseenter, back to 1 on mouseleave
 */

// GSAP animations for fade-in-up-stagger elements
const gsapFadeInUpStaggerAnimations = () => {
	const staggerWrappers = document.querySelectorAll(".fade-in-up-stagger-wrapper");

	if (!staggerWrappers.length) return;

	staggerWrappers.forEach(wrapper => {
		// Animate stagger items
		const animateStaggerItems = () => {
			const staggerItems = wrapper.querySelectorAll(".fade-in-up-stagger-item");

			if (staggerItems.length > 0) {
				var tl = gsap.timeline({
					scrollTrigger: {
						trigger: wrapper,
						start: "top 95%",
						toggleActions: "play none none none",
					},
				});
				
				tl.from(staggerItems, {
					duration: 0.5,
					opacity: 0,
					y: 20,
					scale: 0.8,
					stagger: 0.1,
					ease: "back.out(1.7)"
				});

				// Add hover effects for stagger items
				staggerItems.forEach(item => {
					const link = item.querySelector("a");
					if (link) {
						link.addEventListener("mouseenter", () => {
							gsap.to(link, {
								scale: 1.1,
								duration: 0.3,
								ease: "power2.out"
							});
						});

						link.addEventListener("mouseleave", () => {
							gsap.to(link, {
								scale: 1,
								duration: 0.3,
								ease: "power2.out"
							});
						});
					}
				});
			}
		};

		// Initialize animations for this wrapper
		animateStaggerItems();
	});
};

// Initialize everything when DOM is ready
if (document.readyState !== "loading") {
	gsapFadeInUpStaggerAnimations();
} else {
	document.addEventListener("DOMContentLoaded", () => {
		gsapFadeInUpStaggerAnimations();
	});
}